import React from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';
import { get } from 'lodash-es';
import { useQuery } from 'react-apollo';
import {
  ROUTE_TO_ADMIN_EDIT_USER_PAGE,
  ROUTE_TO_ADMIN_EDIT_EMPLOYEE_PAGE,
  ROUTE_TO_ADMIN_DASHBOARD_PAGE,
} from '../../constants/routes';
import { SingleDamageClaimData } from '../SingleDamageClaimData';
import { isHOKEmployee } from '../../constants/roles';
import { handleRequestError } from '../../constants/errorCodes';
import { GetUsersQuery } from '../../operations/queries/GetUsersQuery';
import { Spinner } from '../../containers';

export const AdminEditSingleClaim = () => {
  const dispatch = useDispatch();
  const params = useParams();

  const damageClaimParam = get(params, 'claimNumber', null);
  const [damageClaimClassOrCode, damageClaimId] = damageClaimParam.split(/-(.+)/);
  const userId = get(params, 'userId', null);

  const { data, loading, error } = useQuery(GetUsersQuery, {
    variables: { filter: { id: parseInt(userId, 10) } },
    onError: error => handleRequestError(error, dispatch),
  });

  const user = get(data, 'getUsers.users[0]', null);

  if ((!data && !error) || loading) {
    return <Spinner className="spinner-positioning" />;
  }

  if (data.getUsers.users.length < 1 || error) {
    return <Redirect to={{ pathname: ROUTE_TO_ADMIN_DASHBOARD_PAGE }} />;
  }

  if (user) {
    const isUserEmployee = isHOKEmployee(user);

    return (
      <SingleDamageClaimData
        baseRoute={`${
          isUserEmployee ? ROUTE_TO_ADMIN_EDIT_EMPLOYEE_PAGE : ROUTE_TO_ADMIN_EDIT_USER_PAGE
        }/${userId}/damage-claims`}
        damageClaimId={damageClaimId === 'null' ? null : damageClaimId}
        damageClaimClassOrCode={damageClaimClassOrCode === 'null' ? null : damageClaimClassOrCode}
        userId={userId}
        user={user}
      />
    );
  }
};
